import { useState } from 'react'
import { getPdfThumbnailUrl } from '../utils'

interface PdfThumbnailProps {
  url?: string
}

const PdfThumbnail = ({ url }: PdfThumbnailProps) => {
  const [failed, setFailed] = useState(false)
  const thumbnailUrl = getPdfThumbnailUrl(url)
  if (!thumbnailUrl) return null

  return (
    <div className="relative h-full w-full overflow-hidden rounded-lg bg-[#EFF0F7]">
      {!failed && (
        <img
          src={thumbnailUrl}
          alt=""
          className="h-full w-full rounded-lg bg-[#EFF0F7] object-cover object-top"
          loading="lazy"
          onError={() => setFailed(true)}
        />
      )}
    </div>
  )
}

export default PdfThumbnail
